import { connect, useSelector } from "react-redux";

import { useState } from "react";
import { confirmAlert } from "react-confirm-alert";

import { Button } from "@material-ui/core";
import { AGENCY_BUSINESS_TYPE, PERMISSION_LEVELS, PERMISSION_MODULES, PRIVACY_LEVEL, TRIGGER_STATUS, TRIGGER_TYPES } from "../../../helpers/CoreConstant";
import Utils from "../../../helpers/Utils";
import { duplicateTrigger } from "../actions/globalTriggerAction";
import { changeStatus, settingGet, settingSave } from "../actions/triggerAction";
import { iconList } from "../IconList";
import { AddorEditGlobalTriggerStyles } from "../TriggerStyle";
import { validateActionValue, validateItemValue } from "./TriggerUtils";
import CustomSwitch from "../Switch/CustomSwitch";


const TriggerSettingsHeaderApp = (props)=> {
    const [triggerStatus,setTriggerStatus] = useState(props.triggerRule.status == TRIGGER_STATUS.STATUS_START);
    const [saving, setSaving] = useState(false);
    const canUserManageGlobalItem = window.hasPermission(
        PERMISSION_MODULES.MANAGE_GLOBAL_ITEMS,PERMISSION_LEVELS.WRITE);
    const hasGlobalFeaturePermission = Utils.getAccountData("agencyBusinessType") === AGENCY_BUSINESS_TYPE.INSURANCE || Utils.getAccountData("hasGlobalFeature");
    const isTriggerPrivate = props.triggerRule.privacy_level === PRIVACY_LEVEL.PRIVACY_LEVEL_PRIVATE;
    const isUserTriggerOwner = props.triggerRule.user_id === Utils.getAccountData("userId");
    const hasPermission = ((hasGlobalFeaturePermission && ((!isTriggerPrivate && canUserManageGlobalItem) || (isTriggerPrivate && isUserTriggerOwner))) || !hasGlobalFeaturePermission);
    const { selectedTriggerActionId } = useSelector(
        (state) => state.triggerSettingReducer);

    const onStatusChange = (status) => {
        try {
            setTriggerStatus(status);
            let changeTo = (status == true) ? TRIGGER_STATUS.STATUS_START : TRIGGER_STATUS.STATUS_PAUSE;
            props.changeStatus({ status : changeTo , triggerRuleId : props.triggerRule.id},(res) => {
                if(res.data.success) {
                    window.showNotification('SUCCESS', res.data.message)
                }else {
                    setTriggerStatus(!status);
                    window.showNotification('ERROR', res.data.message)
                }
            });
        } catch (error) {
            console.log(error)
        }
    }
    const settingSave = () => {

        if(saving) {
            return "";
        }

        //Validate left side setting. We call it item value
        let validate = validateItemValue(props.triggerItemId, props.triggerItemValue);
        if(!validate.status) {
            window.showNotification('ERROR',validate.message);
            return;
        }

        //Validate right side setting. We call it action value
        validate = validateActionValue(props.triggerActionValue);
        if(!validate.status) {
            window.showNotification('ERROR',validate.message);
            return;
        }

        setSaving(true);
        if(triggerStatus == true || triggerStatus == TRIGGER_STATUS.STATUS_START) {
            setTriggerStatus(false);
            props.changeStatus({ status : false , triggerRuleId : props.triggerRule.id},(res) => {
                if(res.data.success) {
                    confirmAlert({
                        title: 'Trigger status turned off due to change in your trigger',
                        buttons: [
                            {
                                label: 'OK',
                                onClick: () => {
                                    
                                }
                            }
                        ]
                    });
                }
            });
        }
        
        confirmAlert({
            title: 'Do you want to turn on this trigger?',
            // message: 'Run the campaign to add contact',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => {
                        props.settingSave(
                            {
                                triggerActionId : props.triggerActionId,
                                triggerActionValue : props.triggerActionValue,
                                triggerItemId : props.triggerItemId,
                                triggerItemValue : props.triggerItemValue,
                                triggerRuleAction : props.triggerRule.rule_trigger_action,
                                triggerRuleId : props.triggerRule.id,
                                requiredError : props.required_error
                            },(res) => {
                                window.showNotification(res.data.success ? 'SUCCESS' : 'ERROR', res.data.message)
                                setSaving(false);
                                if(res.data.success) {
                                    props.settingGet({
                                        triggerRuleId : props.triggerRule.id
                                    });

                                    props.changeStatus({ status : true, triggerRuleId : props.triggerRule.id});
                                    props.handleClose();
                                }
                            }
                        );
                    }
                },
                {
                    label: 'No',
                    onClick: () => {
                        props.settingSave(
                            {
                                triggerActionId : props.triggerActionId,
                                triggerActionValue : props.triggerActionValue,
                                triggerItemId : props.triggerItemId,
                                triggerItemValue : props.triggerItemValue,
                                triggerRuleAction : props.triggerRule.rule_trigger_action,
                                triggerRuleId : props.triggerRule.id,
                                requiredError : props.required_error
                            },(res) => {
                                window.showNotification(res.data.success ? 'SUCCESS' : 'ERROR', res.data.message)
                                setSaving(false);
                                if(res.data.success) {
                                    props.settingGet({
                                        triggerRuleId : props.triggerRule.id
                                    });
                                    props.handleClose();
                                }
                            }
                        );
                    }
                }
            ]
        })

        setSaving(false);
    };

    const {triggerSettingsHeader,  saveButton} = AddorEditGlobalTriggerStyles()

    return (
        <div className={triggerSettingsHeader} key={triggerStatus}>
            <div className="trigger__settings_left d-flex align-items-center">
                <h2 className="trigger__title" style={{ fontSize: 24, margin: '0 30px 0 0' }}>
                    Trigger and Action for <code> &lt;{props.triggerRule.title}&gt;</code>  
                    
                    {/* {!triggerStatus ? <span className="pause-status">Off</span>:<span className="running-status">On</span>} */}
                </h2>
                {/* <CustomSwitch on="On" off="Off" 
                    checked={triggerStatus}
                    onChange={(status) => onStatusChange(status)}
                    disabled={!hasPermission}/> */}
            </div>

            <div className="trigger__btns">
                {(hasPermission || (hasGlobalFeaturePermission && isUserTriggerOwner && selectedTriggerActionId === TRIGGER_TYPES.CUSTOMER_BOOKED_APPOINTMENT))  && (
                    <Button 
                        disabled={saving} 
                        onClick={() => settingSave()} 
                        className={saveButton} 
                        startIcon={iconList.saveIcon}
                    >
                        {saving ? "Saving..." : "Save"}
                    </Button>
                )}
            </div>
        </div>
    )
};

const mapDispatchToProps = dispatch => {
    return {
        changeStatus: (params,callBack) => dispatch(changeStatus(params,callBack)),
        duplicateTrigger: (params,callBack) => dispatch(duplicateTrigger(params,callBack)),
        settingSave : (params,callBack)  =>  dispatch(settingSave(params,callBack)),
        settingGet : (params,callBack)  =>  dispatch(settingGet(params,callBack)),
    };
}

const mapStateToProps = state => ({
    triggerRule: state.triggerSettingReducer.triggerRule,
    triggerItemId: state.triggerSettingReducer.triggerItemId,
    triggerActionId: state.triggerSettingReducer.triggerActionId,
    triggerActionValue: state.triggerSettingReducer.triggerActionValue,
    triggerItemValue: state.triggerSettingReducer.triggerItemValue,
    required_error: state.triggerSettingReducer.required_error,
    defineFilterTrigger: state.triggerSettingReducer.defineFilterTrigger,
});

const TriggerSettingsHeader = connect(mapStateToProps, mapDispatchToProps)(TriggerSettingsHeaderApp);

export default TriggerSettingsHeader; 